import { composeIO } from 'react-compose-io'
import { itemDetalheControleComissaoPedidoIO } from './ItemDetalheControleComissaoPedido.IO'
import { ItemDetalheControleComissaoPedidoView } from './ItemDetalheControleComissaoPedido.View'

export const ItemDetalheControleComissaoPedido = composeIO(ItemDetalheControleComissaoPedidoView, itemDetalheControleComissaoPedidoIO)
